import {Component, Fragment} from 'react';
import React from "react";
import Alert from "react-bootstrap/es/Alert";
import ReactTable from "react-table";
import VMSub from "../subcomponents/VMSub";
import AzureTable from "../AzureTable";
import OverlayTrigger from "react-bootstrap/es/OverlayTrigger";
import Tooltip from "react-bootstrap/es/Tooltip";
import Badge from "react-bootstrap/lib/Badge";

import QRCode from "qrcode";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import request from "request-promise-native";
import LoadingModal from "../modals/LoadingModal";
import FailedDialog from "../../utils/modals/FailedDialog";
import DeviceConfig from "../modals/DeviceConfig";
import Modal from "react-responsive-modal";
import {Button, ButtonGroup, ButtonToolbar, ToggleButton, ToggleButtonGroup} from "react-bootstrap";
import RebootDeviceConfirmModal from "../modals/RebootDeviceConfirmModal";
import GenerateReportModal from "../modals/GenerateReportModal";

window.html2canvas = html2canvas;

const GET_TX_URL = "https://qibipay.azurewebsites.net/api/VMTxList";
const GENERATE_QR_URL = "https://qibipay.azurewebsites.net/api/GenerateTwintQR";
const BASE_LONG_TIMESTAMP = 4102444800*1000; // 1.1.2100 - 12:00 a.m.

const qrBadge = "\n" +
    "\t\t<div class=\"_idGenObjectLayout-2\">\n" +
    "\t\t\t\t<img class=\"_idGenObjectAttribute-1\" src=\"images/beizin.png\" alt=\"\" />\n" +
    "\t\t</div>\n" +
    "\n" +
    "\t\t<div id=\"_idContainer002\" class=\"Einfacher-Textrahmen\">\n" +
    "\t\t\t<p class=\"Einf--Abs- ParaOverride-1\"><span class=\"CharOverride-1\">Twint</span></p>\n" +
    "\t\t</div>\n" +
    "\n" +
    "\t\t<div class=\"_idGenObjectLayout-1\">\n" +
    "\t\t\t<div id=\"_idContainer001\" class=\"_idGenObjectStyleOverride-1\">\n" +
    "\t\t\t\t<img class=\"_idGenObjectAttribute-2\" src=\"%qrSrc%\" alt=\"\" />\n" +
    "\t\t\t</div>\n" +
    "\t\t</div>\n" +
    "\t\t<div id=\"_idContainer003\" class=\"Einfacher-Textrahmen\">\n" +
    "\t\t\t<p class=\"Einf--Abs- ParaOverride-1\"><span class=\"CharOverride-2\">%resName%</span></p>\n" +
    "\t\t</div>\n" +
    "\t\t<div id=\"_idContainer004\" class=\"Einfacher-Textrahmen _idGenObjectStyleOverride-2\">\n" +
    "\t\t\t<p class=\"Einf--Abs- ParaOverride-1\"><span class=\"CharOverride-3\">%tableName%</span></p>\n" +
    "\t\t</div>";

class DeviceScreen extends Component {

    constructor(props) {
        super(props);
        this.state = {
            content: 1,
            rebootDevice: false,
            generateReport: false
        };
    }

    close() {
        if(this.props.onClose!=null) {
            this.props.onClose();
        }
    }

    openConfig() {
        if(this.props.openConfig!=null) {
            this.props.openConfig();
        }
    }

    async generateQRCodes() {
        this.setState({
            qrGenerating: true,
            qrError: null
        });

        const options = {
            method: 'POST',
            uri: GENERATE_QR_URL,
            body: {
                access_code: this.props.access_code,
                regId: this.props.device.regId
            },
            json: true,
            resolveWithFullResponse: true,
            simple: false
        };

        const response = await request(options);

        if(response.statusCode!==200)  {
            if(response.statusCode===500) {
                this.setState({
                    qrGenerating: false,
                    qrError: "Internal server error"
                });
            } else {
                this.setState({
                    qrGenerating: false,
                    qrError: response.body.msg
                });
            }
            return;
        }

        const qrBase = response.body.qr;

        let pdf = new jsPDF('l', 'mm', 'a4');

        const element = document.createElement("div");
        element.classList.add("_idGenObjectLayout-3");
        element.style.marginLeft = "300px";
        document.getElementById("root").appendChild(element);

        if(this.props.device.type==="twintqr") {
            const dataUrl = await new Promise((resolve, reject) => {
                QRCode.toDataURL(qrBase+this.props.device.regId, {
                    margin: 0
                }, function (err, generated) {
                    if(err) {
                        reject(err);
                        return;
                    }
                    resolve(generated);
                })
            });

            element.innerHTML = qrBadge
                .replace(new RegExp("%qrSrc%", 'g'), dataUrl)
                .replace(new RegExp("%resName%", 'g'), this.props.device.name)
                .replace(new RegExp("%tableName%", 'g'), "Scan Me" );

            const canvas = await html2canvas(element, {scale: 3});

            console.log(canvas.width);
            console.log(canvas.height);

            pdf.addImage(canvas, 'PNG', 0, 0, 50.8, 70, null, "MEDIUM");
        } else {
            for(let i=0;i<15;i++) {
                const dataUrl = await new Promise((resolve, reject) => {
                    QRCode.toDataURL(qrBase+this.props.device.regId+";"+(i+1), {
                        margin: 0
                    }, function (err, generated) {
                        if(err) {
                            reject(err);
                            return;
                        }
                        resolve(generated);
                    })
                });

                let iStr = (i+1)<10 ? "0"+(i+1) : (i+1);
                const name = this.props.device.configuration["price"+iStr+"twintqr"];

                element.innerHTML = qrBadge
                    .replace(new RegExp("%qrSrc%", 'g'), dataUrl)
                    .replace(new RegExp("%resName%", 'g'), this.props.device.name)
                    .replace(new RegExp("%tableName%", 'g'), name==null || name==="" ? ""+(i+1) : name );

                const canvas = await html2canvas(element, {scale: 3});

                console.log(canvas.width);
                console.log(canvas.height);

                pdf.addImage(canvas, 'PNG', 21.5+(50.8*(i%5)), 70*(Math.floor(i/5)%3), 50.8, 70, null, "MEDIUM");

                if(i%15===14) {
                    //pdf.addPage();
                    pdf.setFontSize(9);
                }
            }
        }

        document.getElementById("root").removeChild(element);

        pdf.save(this.props.device.name+"_"+new Date().toISOString().replace(new RegExp(":",'g'), "-")+".pdf");

        this.setState({
            qrGenerating: false
        });

    }

    render() {

        let part = [];

        const data = [];

        data.push({
            name: "Registration ID",
            value: this.props.device.regId
        });

        data.push({
            name: "Config state",
            value: this.props.device.config
        });

        data.push({
            name: "Status",
            value: this.props.device.status
        });

        data.push({
            name: "Last contact",
            value: this.props.device.lastSetStatus==null ? "Never" : new Date(this.props.device.lastSetStatus).toLocaleString()
        });

        data.push({
            name: "Watch-only endpoint",
            value: this.props.device.deviceInfoUrl
        })

        if(this.props.device.mqttConnected!==undefined) {
            data.push({
                name: "Payment server connection",
                value: this.props.device.mqttConnected ? "Online" : "Offline"
            });

            data.push({
                name: "Connection count",
                value: this.props.device.mqttConnectionCounter==null ? "0" : ""+this.props.device.mqttConnectionCounter
            });
        }

        if(this.props.device.DeviceInfo!=null) for(let field in this.props.device.DeviceInfo) {
            data.push({
                name: field,
                value: this.props.device.DeviceInfo[field]
            })
        }

        if(data.length===3) {
            part.push((
                <Alert bsStyle="warning">
                    <strong>Device info not yet available!</strong> This can be caused by using older version of Flexa firmware or by the fact that the device hasn't yet contacted QIBaccount service
                </Alert>
            ));
        }

        part.push((
            <ReactTable
                showPagination={false}
                sortable={false}
                filterable={false}
                pageSize={data.length}
                data={data}
                columns={[
                    {
                        //Header:"Device information",
                        accessor: "name",
                        maxWidth: 300,
                        Cell: (row) => (
                            <b>{row.original.name}</b>
                        )
                    },
                    {
                        accessor: "value",
                    }
                ]}
            />
        ));

        let content = "";

        if(this.state.content===1) {
            content = (
                <Fragment>

                    <div className="">
                        <div className="row">
                            <div className="col-12 ml-3 mb-3 d-flex no-block align-items-center">
                                <h3 className="page-title"><i className="fa fa-info"></i> Device information</h3>
                            </div>
                        </div>
                    </div>
                    {part}
                </Fragment>
            );
        }
        if(this.state.content===3) {
            content = (
                <Fragment>
                    <div className="">
                        <div className="row">
                            <div className="col-12 ml-3 mb-3 d-flex no-block align-items-center">
                                <h3 className="page-title"><i className="fa fa-chart-bar"></i> Chart</h3>
                            </div>
                        </div>
                    </div>


                    <VMSub
                        revalues={this.props.device.revalues}
                        revenues={this.props.device.revenues}
                        currency={this.props.currency}
                    />


                    <div className="">
                        <div className="row">
                            <div className="col-12 ml-3 mb-3 mt-5 d-flex no-block align-items-center">
                                <h3 className="page-title"><i className="fa fa-money-bill-alt"></i> Transactions</h3>

                                <button className="btn btn-success ml-auto" onClick={() => {
                                    this.setState({
                                        generateReport: true
                                    });
                                }}><i className="mdi mdi-receipt font-16"></i> Generate report</button>
                            </div>
                        </div>
                    </div>


                    <AzureTable
                        additionalData={
                            {
                                regId: this.props.device.regId
                            }
                        }
                        logout={this.props.logout}
                        access_code={this.props.access_code}
                        onLoad={() => {
                        }}
                        tableRef={(ref) => {
                            this.tableRef = ref;
                        }}
                        functionUrl={GET_TX_URL}
                        defaultSorted={[
                            {
                                id: "timestamp",
                                desc: true
                            }
                        ]}
                        columns={[
                            {
                                Header: "Timestamp",
                                accessor: "timestamp",
                                filterable: false,
                                Cell: row => new Date(row.original.timestamp).toLocaleString(),
                                sortable: false,
                                width: 150
                            },
                            {
                                Header: "Type",
                                accessor: "src",
                                filterable: true,
                                sortable: false,
                                width: 150
                            },
                            {
                                Header: "Amount",
                                accessor: "amount",
                                Cell: row => (
                                    <Badge>{row.original.amount == null ? "-" : Number(row.original.amount).toFixed(2)}</Badge>
                                ),
                                filterable: false,
                                sortable: false,
                                width: 150
                            },
                            {
                                Header: "Description",
                                accessor: "description",
                                sortable: false,
                                filterable: false
                            }
                        ]}
                        defaultPageSize={10}
                        className="-striped -highlight"
                        pageSize={10}
                    />
                </Fragment>
            )
        }

        return (
            <div className="page-wrapper">

                <GenerateReportModal
                    access_code={this.props.access_code}
                    regId={this.props.device.regId}
                    deviceName={this.props.device.name}
                    open={this.state.generateReport}
                    onClose={() => {
                        this.setState({
                            generateReport: false
                        })
                    }}
                    logout={this.props.logout}
                />

                <RebootDeviceConfirmModal
                    access_code={this.props.access_code}
                    device={this.props.device}
                    open={this.state.rebootDevice}
                    onClose={() => {
                        this.setState({
                            rebootDevice: false
                        })
                    }}
                    onDeviceReboot={this.props.onDeviceReboot}
                    logout={this.props.logout}
                />

                <LoadingModal
                    text={"Generating TWINT QR codes"}
                    title={"Generating..."}
                    open={this.state.qrGenerating}
                />

                <FailedDialog open={this.state.qrError!=null}
                              title="QR code generation failed"
                              text={this.state.qrError}
                              onClose={() => {
                                  this.setState({
                                      qrError: null
                                  });
                              }}/>

                <div className="page-breadcrumb">
                    <div className="row">
                        <div className="col-12 d-flex no-block align-items-center">
                            <h3 className="page-title"><a href="#" onClick={this.close.bind(this)}><i className="mdi mdi-arrow-left font-24"></i></a> <i className="mdi mdi-chip"></i> {this.props.device.name} </h3>
                            <div className="ml-auto text-right">
                                {this.props.device.type==="contact" || this.props.device.type==="twintqr" ? <button className="btn btn-success mx-3" onClick = {this.generateQRCodes.bind(this)}>
                                    <i className="mdi mdi-creation font-16"></i> Generate TWINT QRs
                                </button> : ""}
                                <button className="btn btn-warning mx-3" onClick={() => {
                                    this.setState({
                                        rebootDevice: true
                                    });
                                }}><i className="mdi mdi-restart font-16"></i> Reboot</button>
                            </div>
                        </div>
                    </div>
                </div>


                <div className="container-fluid">

                    {this.state.content===2 ? (
                        <button className="btn btn-warning float-right" onClick = {this.submitRef}>
                            <i className="mdi mdi-floppy font-16"></i> Save
                        </button>
                    ) : ""}
                    <ButtonToolbar className={"mb-3"}>
                        <ToggleButtonGroup bsSize="large" type="radio" name="options" defaultValue={1}>
                            <ToggleButton value={1} onClick={() => {
                                this.setState({
                                    content: 1
                                })
                            }}><i className="fa fa-info"></i> Device info</ToggleButton >
                            <ToggleButton value={2} onClick={() => {
                                this.setState({
                                    content: 2
                                })
                            }}><i className="fa fa-cog"></i> Configuration</ToggleButton >
                            <ToggleButton value={3} onClick={() => {
                                this.setState({
                                    content: 3
                                })
                            }}><i className="fa fa-chart-bar"></i> Chart & Transactions</ToggleButton >
                        </ToggleButtonGroup>
                    </ButtonToolbar>

                    <DeviceConfig
                        admin={this.props.admin}
                        access_code={this.props.access_code}
                        open={this.state.content===2}
                        tableRef={this.props.tableRef}
                        logout={this.props.logout}
                        device={this.props.device}
                        submitFunc={(subRef) => {
                            this.submitRef = subRef;
                        }}
                    />

                    {content}

                </div>

            </div>
        );
    }

}

export default DeviceScreen;
